<template>
    <el-table :data="tableData" :columns="mergedColumns" :height="height" v-loading="loading"
        @selection-change="handleSelectionChange" @row-click="handleRowClick" v-bind="tableConfig">
        <el-table-column type="index" width="50" v-if="tableConfig.isIndex" label="序号">
        </el-table-column>
        <el-table-column type="selection" width="55" v-if="!tableConfig.noCheck"></el-table-column>
        <el-table-column v-for="(column, index) in mergedColumns" show-overflow-tooltip :key="index" :prop="column.prop"
            :label="column.label" :formatter="column.formatter">
            <template slot-scope="scope">
                <slot :name="column.slot" :row="scope.row" :index='scope.$index'>
                    <span v-html="column.formatter ? column.formatter(scope.row[column.prop], scope.row) || '-' :
                        (scope.row[column.prop] !== null ? scope.row[column.prop] : '-')"></span>
                </slot>
            </template>

        </el-table-column>
        <slot></slot>
    </el-table>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            required: true,
        },
        tableConfig: {
            type: Object,
            default: _ => {
                return {
                    noCheck: false,
                    isIndex: false,
                }
            }
        },
        columns: {
            type: Array,
            required: true,
        },
        height: {
            type: Number | String,
            default: '100%',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        mergedColumns () {
            // 在这里可以合并自定义列和默认列配置
            return [...this.columns];
        },
    },
    methods: {
        handleSelectionChange (selection) {
            this.$emit('selection-change', selection);
        },
        handleRowClick (row) {
            this.$emit('row-click', row);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/myTable.vue